<template>
  <div>
    <div ref='recordBulkSubscriptionForm' aria-hidden="true" class="modal fade hidden" role="dialog" tabindex='-1'>
      <div class="modal-dialog">
        <div class="modal-content">
        <form ref="recordBulkSubscriptionEventForm"  @submit.prevent="recordSubscribe($event)">
        <div class="modal-header">
          <h5 class="modal-title mt-0">
            <span>{{ $t('folder_show.activities.subscribe_to_record_bulk') }}</span>
          </h5>
        </div>
        <div class='modal-body text-left'>
          <p>{{ $t('folder_show.activities.subscribe_updates') }}:</p>
          <label class="checkbox-container">
            {{ $t('records_list.events.expiration_changed') }}
            <input type="checkbox" name="record_subscription_events[event_group][]" value="expiration_changed" v-model='eventSubs'>
            <span class="checkmark" data-toggle="tooltip" title=""></span>
          </label>
          <label class="checkbox-container">
            {{ $t('records_list.events.note_changed') }}
            <input type="checkbox" name="record_subscription_events[event_group][]" value="note_changed" v-model='eventSubs'>
            <span class="checkmark" data-toggle="tooltip" title=""></span>
          </label>
          <label class="checkbox-container">
            {{ $t('records_list.events.version_changed') }}
            <input type="checkbox" name="record_subscription_events[event_group][]" value="version_changed" v-model='eventSubs'>
            <span class="checkmark" data-toggle="tooltip" title=""></span>
          </label>

          <br/>
          <p>{{ $t('folder_show.activities.record_notify_via') }}:</p>
          <label class="checkbox-container">
            {{ $t('folder_show.activities.notify_email') }}
            <input type="checkbox" name="record_subscription_events[activity_notify_via][]" value="email" v-model='notificationMedium'>
            <span class="checkmark" data-toggle="tooltip"></span>
          </label>
          <label class="checkbox-container">
            {{ $t('folder_show.activities.notify_app') }}
            <input type="checkbox" name="record_subscription_events[activity_notify_via][]" value="app" v-model='notificationMedium'>
            <span class="checkmark" data-toggle="tooltip"></span>
          </label>

          <br/>
          <p>{{ $t('folder_show.activities.frequency_days') }}:</p>
          <label class="radio-container">
            {{ $t('folder_show.activities.notify_immediately') }}
            <input type="radio" name="record_subscription[activity_notify_days]" value="0" v-model='notificationInterval'>
            <span class="radiomark" data-toggle="tooltip"></span>
          </label>
          <label class="radio-container">
            {{ $t('folder_show.activities.notify_weekly') }}
            <input type="radio" name="record_subscription[activity_notify_days]" value="7" v-model='notificationInterval'>
            <span class="radiomark" data-toggle="tooltip"></span>
          </label>
          <label class="radio-container">
            {{ $t('folder_show.activities.bi_weekly') }}
            <input type="radio" name="record_subscription[activity_notify_days]" value="14" v-model='notificationInterval'>
            <span class="radiomark" data-toggle="tooltip"></span>
          </label>
          <label class="radio-container">
            {{ $t('folder_show.activities.monthly') }}
            <input type="radio" name="record_subscription[activity_notify_days]" value="30" v-model='notificationInterval'>
            <span class="radiomark" data-toggle="tooltip"></span>
          </label>
        </div>
        <div class="modal-footer">
          <button type='submit' class="btn btn-primary float-right" :disabled='!canSubmit || isProcessing'>
            {{ $t('folder_show.activities.subscribe') }}
            <i class="fas fa-circle-notch fa-spin" v-show="isProcessing"></i>
          </button>
        </div>
        </form>
       </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        records: [],
        currentRecord: {},
        isProcessing: false,
        eventSubs: [],
        notificationInterval: null,
        notificationMedium: [],
      }
    },
    computed: {
      subscription() {
        return this.state.recordSubscription || {}
      },
      recordIds(){
        return this.records.map(r => r.id) || []
      },
      canSubmit() {
        return this.eventSubs.length > 0 && this.notificationMedium.length > 0 && this.notificationInterval
      }
    },
    methods: {
      open(records) {
        this.records = records
        $(this.$refs.recordBulkSubscriptionForm).modal('show')
      },
      closeModal() {
        $(this.$refs.recordBulkSubscriptionForm).modal('hide')
      },
      success() {
        this.$emit('success')
      },
      recordSubscribe(e) {
        this.isProcessing = true

        const params = new FormData(e.target)

        this.recordIds.forEach(function (id) {
          params.append('ids[]', id)
        });

        this.store.bulkCreateRecordSubscription(params).then(() => {
           this.$toastr.success(this.$t('folder_show.activities.successfully_subscribed'))
           this.store.sendMetrics({name: 'record_subscribe', params: this.$route.params, path: this.$route.fullPath})
          this.success()
          this.isProcessing = false
           e.target.reset()
          this.closeModal()
        }).catch(() => {
           this.isProcessing = false
           this.closeModal()
        })
      }
    }
  }
</script>
